import { getCustomerType, isScopedToken } from "@origin-digital/auth-utils";
import { CustomerType } from "@origin-digital/platform-enums";
import { IFetchAccessToken } from "@origin-digital/event-dispatcher";
import { PlatformParameters } from "@origin-digital/mcapp-registry";

export const fetchPlatformParameters = async (
  fetchAccessToken: IFetchAccessToken["result"]
): Promise<Pick<PlatformParameters, "customerType" | "scopedToken">> => {
  let accessToken;
  let customerType = CustomerType.unauthenticated;
  let scopedToken = false;
  if (fetchAccessToken) {
    try {
      const result = await fetchAccessToken.then();
      if (result && result.accessToken) {
        accessToken = result.accessToken;
        customerType = getCustomerType(accessToken);
        scopedToken = isScopedToken(accessToken);
      }
    } catch (e) {
      // this is okay, use the defaults
    }
  }
  return {
    customerType,
    scopedToken,
  };
};
